export type FormatDate = (date?: string) => string;

export const formatDate: FormatDate = (date = "") => date.replace(/\./g, "/");
